import { render, staticRenderFns } from "./PersonalInfoTab2.vue?vue&type=template&id=2e72626b"
import script from "./PersonalInfoTab2.vue?vue&type=script&lang=js"
export * from "./PersonalInfoTab2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e72626b')) {
      api.createRecord('2e72626b', component.options)
    } else {
      api.reload('2e72626b', component.options)
    }
    module.hot.accept("./PersonalInfoTab2.vue?vue&type=template&id=2e72626b", function () {
      api.rerender('2e72626b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/PersonalInfoTab2.vue"
export default component.exports